import Resource from '@/api/resources/Resource'

class SampleObservationsService extends Resource {
    async findById(labId, casId, samId) {
        return this.axios.get(`/laboratories/${labId}/cases/${casId}/samples/${samId}/observations`)
            .then(response => response.data)
    }

    async update(labId, casId, samId, clob) {
        return this.axios.put(`/laboratories/${labId}/cases/${casId}/samples/${samId}/observations`, clob)
            .then(response => response.data)
    }
}

export default new SampleObservationsService()
